import {
  Users,
  CreditCard,
  BarChart2,
  User,
  Wallet,
  PieChart,
  HandCoins,
} from "lucide-react";
import { PERMISSIONS } from "../contexts/permissions";
import { FourCircles } from "../components/leftbar/Circles";

export const menuItems = [
  {
    id: "dashboard",
    label: "Dashboard",
    route: "/dashboard",
    icon: <FourCircles size={20} color="#FFFFFF8F" />,
    permissions: [
      PERMISSIONS?.DB?.VIEW_CASH,
      PERMISSIONS?.DB?.VIEW_LOAN_VOLUME,
      PERMISSIONS?.DB?.VIEW_OUTSTANDING,
      PERMISSIONS?.DB?.VIEW_DEFAULTED,
      PERMISSIONS?.DB?.VIEW_ACTIVE_ACCOUNTS,
      PERMISSIONS?.DB?.VIEW_ACTIVITY,
      PERMISSIONS?.DB?.VIEW_DEPOSITS,
      PERMISSIONS?.DB?.VIEW_SHARES_VOLUME,
      PERMISSIONS?.DB?.VIEW_MANUAL_REVIEW,
    ],
  },
  {
    id: "members",
    label: "Members",
    route: "/dashboard/customers",
    icon: <Users size={20} color="#FFFFFF8F" />,
    permissions: [
      PERMISSIONS?.MB?.VIEW_ALL,
      PERMISSIONS?.MB?.ADD_NEW,
      PERMISSIONS?.MB?.EXPORT_LIST,
      PERMISSIONS?.MB?.VIEW_DETAILS,
      PERMISSIONS?.MB?.EDIT_INFO,
    ],
  },
  {
    id: "transactions",
    label: "Transactions",
    route: null,
    icon: <CreditCard size={20} color="#FFFFFF8F" />,
    permissions: [
      PERMISSIONS?.TX?.VIEW_ALL,
      PERMISSIONS?.TX?.VIEW_SUMMARY,
      PERMISSIONS?.TX?.UPLOAD_BULK,
    ],
    submenus: [
      {
        label: "All Transactions",
        route: "/dashboard/transactions",
        permissions: [
          PERMISSIONS?.TX?.VIEW_ALL,
          PERMISSIONS?.TX?.VIEW_SUMMARY,
        ],
      },
      {
        label: "Bulk Repayment",
        route: "/dashboard/bulk-repayment",
        permissions: [PERMISSIONS?.TX?.UPLOAD_BULK],
      },
    ],
  },
  {
    id: "loans",
    label: "Loans",
    route: null,
    icon: <HandCoins size={20} color="#FFFFFF8F" />,
    permissions: [
      PERMISSIONS?.LN?.VIEW_BOOK,
      PERMISSIONS?.LN?.VIEW_APPLICATIONS,
      PERMISSIONS?.LN?.APPROVE_REJECT,
      PERMISSIONS?.LN?.VIEW_VOLUME,
      PERMISSIONS?.LN?.MODIFY_TERMS,
    ],
    submenus: [
      {
        label: "Loans",
        route: "/dashboard/loans",
        permissions: [PERMISSIONS?.LN?.VIEW_BOOK],
      },
      {
        label: "Guarantors",
        route: "/dashboard/guarantors",
        permissions: [PERMISSIONS?.LN?.VIEW_GUARANTORS_SUMMARY],
      },
    ],
  },
  {
    id: "savings",
    label: "Savings",
    route: "/dashboard/savings",
    icon: <Wallet size={20} color="#FFFFFF8F" />,
    permissions: [PERMISSIONS?.SV?.VIEW_ALL],
  },
  {
    id: "shares",
    label: "Shares",
    route: "/dashboard/shares",
    icon: <PieChart size={20} color="#FFFFFF8F" />,
    permissions: [PERMISSIONS?.SH?.VIEW_ALL],
  },
  {
    id: "reports",
    label: "Reports",
    route: "/dashboard/reports",
    icon: <BarChart2 size={20} color="#FFFFFF8F" />,
    permissions: [PERMISSIONS?.RP?.VIEW],
  },
  {
    id: "users",
    label: "User Management",
    route: "/dashboard/userManagement/users",
    icon: <User size={20} color="#FFFFFF8F" />,
    permissions: [PERMISSIONS?.UM?.VIEW_ALL],
  },
];
